export default "__VITE_PUBLIC_ASSET__bdc7180a__"